import React from 'react';

const ChannelSelectorNoChannel = () => {
  return (
    <div className={`ChannelSelector__channel`}>
      <i className="far fa-comments-alt"></i>
      <span>Select channel to respond</span>
    </div>
  );
};

export default ChannelSelectorNoChannel;
